import { render, staticRenderFns } from "./FixedBottomBar_OP.vue?vue&type=template&id=2468dcda&scoped=true&"
import script from "./FixedBottomBar_OP.vue?vue&type=script&lang=js&"
export * from "./FixedBottomBar_OP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2468dcda",
  null
  
)

export default component.exports